module.exports = __webpack_public_path__ + "static/media/Nami.e8bad580.png";